// Custom BF Components
// This component also serves the bfcomp component

<template>
    <component :is="comp.html ? 'html-renderer-old' : 'vue-form-generator'"
            class="bf-comp "

            :template="theTemplate" 
            :schema="theSchema"
            :model="theModel" 
            :ref="'comp_'+_uid" 
            :key="'comp_'+_uid" 
            :options="formOptions"
            :value="value"  
            :app="$store.state.site.content.app"  
            :params="$store.state.site.content.params"  
            >
    </component>
</template>

<script>
    import store from "Js/store";
    export default {
        props: [name],
        name: 'BfComponent',
        mixins: [VueFormGenerator.abstractField],
        methods: {
        validate: function() {
            this.errors = []
            this.$children.forEach(function(child, index){
                if (child.validate && !child.validate()) {
                    this.errors.push(
                      this.schema.errorMsg || 'Error'
                    );
                    Vue.set(this.sectionErrors, index, true)
                    
                    store.dispatch( "LOG_ERRORS_VAL", { [this.schema.name || this._uid]: true } )
                }
                else {
                    Vue.set(this.sectionErrors, index, false)
                }
            }.bind(this));
            this.model.errors
            return this.errors
        },
        },
        computed: {
            comp: function() { 
                let name = this.$attrs.name || this.schema.name
                let component = this.$attrs.source || _.get(this, 'schema.source') || this.$store.getters['components'](name)
                if (!component ) {
                    BF.errorThrow (10030, 'Custom component not found' , {name})
                    return {
                            "html": `<h4 style="padding: 8px;color: red;background-color: #ffdede;">Component <b style="color:black;">'${name}'</b> not found</h4>`
                        }
                }
                // Does the scehma have prop fields or schema.foields to override?
                // debugger
                let fields = this.$attrs.fields || _.get(this, 'schema.fields') 
                fields ? component.comp.fields = fields : null
                return component.comp
            },
            theSchema: function(){
                var x =  this.comp
                return Object.assign({} ,this.comp, this.$attrs, this.schema ) // this may break calcs
            },
            theFields: function(){
                return { fields:this.comp.fields }
            },
            theTemplate: function() { 
                let divWrapper = 'divWrapper' in this.comp ? this.comp.divWrapper : false
                return divWrapper ? `<div class="bfcomp-wrapper" style="width: 100%;">${this.comp.html}</div>` : this.comp.html
                // return '<div class="bfcomp-wrapper">' + this.comp.html + '</div>'
            },
            
            value: function(){return null},
            
            theModel: function() { 
                return this.$attrs.modelSource  || this.model || this.comp.modelDev }
        },

        errorCaptured(err, vm, info) {
            console.log(`Component errorCaptured: ${err.toString()}\ninfo: ${info}`);
            return false;
        },
        
        data() {
            return {
                     sectionErrors: [],
            }
        }
        
    }
</script>

<style>
    .bf-comp {
        width: 100%
    }
</style>

                             
